type UserModalType = 'Edit User' | 'Create User' | 'View Preferences';

const UserModalTypes = {
  EditUser: 'Edit User' as UserModalType,
  CreateUser: 'Create User' as UserModalType,
  ViewPreferences: 'View Preferences' as UserModalType,
};

export { UserModalTypes };
export type { UserModalType };
